var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.334,
    viewBox: "0 0 16 13.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8254",
    "data-name": "Path 8254",
    d: "M16.056,130.667H14.722v-2.222a.444.444,0,0,0-.444-.444H12.5a.444.444,0,0,0,0,.889h1.333v1.778H2.278a.889.889,0,1,1,0-1.778H4.5a.444.444,0,1,0,0-.889H2.278A1.779,1.779,0,0,0,.5,129.778v9.778a1.78,1.78,0,0,0,1.778,1.778H16.056a.444.444,0,0,0,.444-.444v-9.778A.444.444,0,0,0,16.056,130.667ZM2.278,140.445a.89.89,0,0,1-.889-.889v-8.247a1.758,1.758,0,0,0,.889.247H15.611v2.667H12.5a.444.444,0,0,0-.444.444v2.667a.444.444,0,0,0,.444.444h3.111v2.667Zm13.333-3.556H12.944v-1.778h2.667Zm0,0",
    transform: "translate(-0.5 -128)",
    fill: "#142249"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.e42ba5c4f8b52710e57cdf97715746a2.svg";
export { ForwardRef as ReactComponent };